<swiper-container
  slides-per-view="1"
  autoplay="true"
  autoplay-delay="10000"
  autoplay-disable-on-interaction="false"
  loop="true"
  class="callout"
  >
  @for (item of items | async; track item; let i = $index) {
    <swiper-slide>
      <app-generic-callout
        [head]="item.title"
        [subhead]="item.description"
        [image]="item.imageUrl"
        [link]="item.link"
        [color]="getColor(i)"
        side="left"
      ></app-generic-callout>
    </swiper-slide>
  }
</swiper-container>
